<template>
  <v-app>
    <v-content>
      <v-form ref="form">
        <v-file-input
          ref="inputImage"
          label="Article Header Image"
          prepend-icon="mdi-file-image"
          v-model="image"
        >
        </v-file-input>
        <v-btn @click="submitForm" color="primary">
          Submit
        </v-btn>
      </v-form>
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable no-console */
import axios from "axios";
import { SERVER_ENDPOINT, UPLOAD_IMAGE_ENDPOINT } from "@/utils/constant";
export default {
  data() {
    return {
      image: null,
    };
  },
  name: "TestUpload",
  methods: {
    async submitForm() {
      const formData = new FormData();
      formData.append("file_image", this.image);
      try {
        const wtf = await axios.post(
          SERVER_ENDPOINT + UPLOAD_IMAGE_ENDPOINT,
          formData
        );
        console.log(wtf.data);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
